module.exports = __webpack_public_path__ + "media/assets/ol_li_ruby-14c43d0ed44e05d3a266d50c47200612.svg";